import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import HeaderComponent from "../headerComponent/headerComponent";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import HomeIcon from "@mui/icons-material/Home";
import Newspaper from "@mui/icons-material/Newspaper";
import SupervisedUserCircle from "@mui/icons-material/SupervisedUserCircle";
import Title from "@mui/icons-material/Subtitles";
import {useNavigate} from "react-router-dom";
import IranSanse from "../../Typography/IranSanse.tsx";
import { styled } from "@mui/material/styles";
import {useState} from "react";
import {blue, green} from "@mui/material/colors";
import LiveStream from "../../LiveStream/LiveStream.tsx";
import {LiveTv} from "@mui/icons-material";

const BottomNavigationAction2 = styled(BottomNavigationAction)(`
  color: green;
  &.Mui-selected {
    color: green;
  }
`);

const colorFunc = () => {

}
const PageLayout = (props) => {
    const [value2,setValue2] = useState('');
    const nav = useNavigate();

    return <div>
        <Row className="g-0">
            <Col>
                <HeaderComponent/>
                <div dir="rtl g-0" ref={props.ref} style={{
                    position: 'relative',
                    height: 'calc(100vh - 100px)',
                    overflowY: 'scroll',
                    WebkitScrollSnapType: 'x',
                    marginBottom: '0',
                    paddingRight: 10
                }}>
                    <CssBaseline/>
                    <div className='py-0 mx-0'>
                        {props.children}
                    </div>
                    <Paper sx={{position: 'fixed', bottom: 0, left: 0, right: 0}}>
                        <BottomNavigation
                            className={'g-0'}
                            showLabels
                            value={value2}
                            defaultChecked={false}
                            onChange={(event, newValue) => {
                                setValue2(newValue)
                                nav('/' + newValue)
                                // props.history.push('/' + newValue)
                            }}>
                            <BottomNavigationAction2 style={{ color : value2 === '' ? 'blue': 'green'}}
                                value=""
                                label={<IranSanse>خانه</IranSanse>}
                                icon={<HomeIcon/>}/>
                            <BottomNavigationAction2
                                style={{ color : value2 === 'News' ? 'blue': 'green'}}
                                value="News"
                                label={<IranSanse>اخبار و برنامه</IranSanse>}
                                icon={<Newspaper/>}/>
                            <BottomNavigationAction2
                                style={{ color : value2 === 'Live' ? blue["900"]: green["900"]}}
                                value="Live"
                                label={<IranSanse>پخش زنده</IranSanse>}
                                icon={<LiveTv/>}/>
                            <BottomNavigationAction2
                                style={{ color : value2 === 'Khoddam' ? 'blue': 'green'}}
                                value="Khoddam"
                                label={<IranSanse>خدام</IranSanse>}
                                icon={<SupervisedUserCircle/>}/>
                            <BottomNavigationAction2
                                style={{ color : value2 === 'Prayers' ? blue["900"]: green["900"]}}
                                value="Prayers"
                                label={<IranSanse>ادعیه</IranSanse>}
                                icon={<Title/>}/>

                        </BottomNavigation>
                    </Paper>

                </div>
            </Col>
        </Row>
    </div>;
}
export default PageLayout;


// }
// class PageLayout extends Component {
//     // constructor(props) {
//     //     super(props);
//     //     this.ref = React.createRef();
//     // }
//
//     render() {
//         // const navigate = useNavigate();
//         return (
//
//             <Row className="g-0">
//                 <Col>
//                     <HeaderComponent/>
//                     <div dir="rtl g-0" ref={this.props.ref} style={{
//                         position: 'relative',
//                         height: 'calc(100vh - 100px)',
//                         overflowY: 'scroll',
//                         WebkitScrollSnapType: 'x',
//                         marginBottom: '0'
//                     }}>
//                         <CssBaseline/>
//                         <div className='py-0 mx-0'>
//                             {this.props.children}
//                             {/*{location?.pathname === '/'  || location?.pathname === '/home' || location?.pathname === ''   ? <FirstPage/>*/}
//                             {/*    : location?.pathname.toLowerCase() === '/news' ? <ShrineNews/>*/}
//                             {/*        : location?.pathname.toLowerCase() === '/prayers' ? <Prayers/>*/}
//                             {/*            : location?.pathname.toLowerCase() === '/prayers' ? <Prayers/>*/}
//                             {/*                : <div>{location?.pathname}</div>*/}
//                             {/*}*/}
//                         </div>
//                         <Paper sx={{position: 'fixed', bottom: -5, left: 0, right: 0}}>
//                             <BottomNavigation
//                                 showLabels
//                                 value={this.value}
//                                 onChange={(event, newValue) => {
//                                     // navigate('/' + newValue)
//                                     console.log(newValue);
//                                     console.log(this);
//                                     this.props.history.push('/' + newValue)
//                                 }}>
//
//                                 <BottomNavigationAction value="" label="خورشید حرم" icon={<HomeIcon/>}/>
//                                 <BottomNavigationAction value="News" label="اخبار" icon={<Newspaper/>}/>
//                                 <BottomNavigationAction value="*" label="خدام" icon={<SupervisedUserCircle/>}/>
//                                 <BottomNavigationAction value="Prayers" label="ادعیه" icon={<Title/>}/>
//                             </BottomNavigation>
//                         </Paper>
//
//                     </div>
//                 </Col>
//             </Row>
//             // <div>
//             //     <Header></Header>
//             //     <div className="baseTemplate-main-content pt-5" >{this.props.children}</div>
//             //     {/*<Footer></Footer>*/}
//             // </div>
//         );
//     }
// }

